export const discountedPrice = (totalPrice, discountValue) => {
    const discountAmount = totalPrice * discountValue / 100;
    const priceAFterDiscount = totalPrice - discountAmount;
    return Math.round(priceAFterDiscount)
}

export const convertDateToString = (date) => {
    const dated = new Date(date).toDateString()
    return dated
}

export const getBookingDate = () => {
    const addDays = (days) => {
        let date = new Date();
        date.setDate(date.getDate() + days);
        return date;
    }

    const newArray = Array.from({ length: 10 }, (_, i) => i + 1).map((num) => addDays(num).toDateString())
    return newArray
}

export const navigation = [
    { name: "Home", link: '/' },
    { name: "Neurologist", link: 'doctor/neurologist' },
    { name: "Dermatologist", link: 'doctor/dermatologist' },
    { name: "Cardiologist", link: 'doctor/cardiologist' },
    { name: "Gastroenterologist", link: 'doctor/gastroenterologist' },
    { name: "Oncologist", link: 'doctor/oncologist' },
    { name: "Psychiatrist", link: 'doctor/psychiatrist' },
    { name: "Pediatrician", link: 'doctor/pediatrician' },
    { name: "Hematology", link: 'doctor/hematology' },
]